import React, { useState, useEffect } from "react";
import Loader from "react-loader-spinner";
import LeftSideNavigation from "../../../vendorDashboardComponents/navigationSection/LeftSideNavigation";
import HomeReusableTopBarNavigation from "../../superAdminReusable/superAdminHomeButton/HomeReusableTopBarNavigation";
import { Table, Image, Button, Form, Col, Row } from "react-bootstrap";
import { Menu, MenuItem } from "@material-ui/core";
import SelectFilter from "../../../reusableComponents/selectFilter";
import { RightSideCountTop } from "./orderingReports/SuperAdminPendingOrderActivityReports";
import { userRegistrations_Amealio_get } from "../../../../store/actions/SuperAdminActions/SuperAdminUserregistrations";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import moment from "moment";
import isEmpty from "../../../../store/validation/is-Empty";
import BasicPagination from "../../../Pagination/Pagination";
import Alert from "react-s-alert";
import { useFormik } from "formik";
import * as yup from "yup";
import CSVDownloader from "../../../reusableComponents/csvDownload/csvDownload";
import { NewInputText } from "../../../reusableComponents/inputReusableComponent/InputBoxComponent";
import NoContent from "../../../reusableComponents/NoContentComponent";

// Animations
import styled, { keyframes } from "styled-components";
import { zoomIn } from "react-animations";
const zoomAnimation = keyframes`${zoomIn}`;
const ZoomDiv = styled.div`
  animation: 1s ${zoomAnimation};
`;
// End Animations
function UserRegistrationAmealio(props) {
  const [page, setPage] = useState(1);
  const [start, setStart] = useState(0);
  const [end, setEnd] = useState(10);
  const [dateQuery, setDateQuery] = useState({
    // startDate: moment().format("YYYY-MM-DD"),
    // endDate: moment().format("YYYY-MM-DD"),
  });

  const handleBatchChange = (pageNo) => {
    window.scrollTo(0, 0);
    var calcStart = pageNo * 10 - 10;
    setStart(calcStart);
    setEnd(pageNo * 10);
    setPage(pageNo);
  };

  const onDateChangeHandler = () => (data, type) => {
    setDateQuery(data);
  };

  const getData = () => {
    props.userRegistrations_Amealio_get(props.auth.user.accessToken, dateQuery);
  };

  useEffect(
    (async) => {
      const DateForm = {
        startDate: moment().format("YYYY-MM-DD"),
        endDate: moment().format("YYYY-MM-DD"),
      };
      if (!isEmpty(dateQuery)) {
        getData(
          props.auth.user.accessToken,
          dateQuery.startDate === "undefined" ? DateForm : dateQuery
        );
      }
    },
    [dateQuery]
  );

  const [state, setState] = useState({
    displaySearch: false,
    displayFilter: false,
    filterApply: false,
    displayDeleteModal: false,
    search: "",
    filterNumber: "",
  });
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [userSort, setUserSort] = useState("");

  /***********************************
   * @DESC SEARCH INPUT
   ***********************************/
  const onClickSearch = (e) => {
    e.preventDefault();
    setState({
      ...state,
      displaySearch: !state.displaySearch,
      displayFilter: false,
    });
  };
  const onChangeSearch = (e) => {
    e.preventDefault();
    setState({
      ...state,
      search: e.target.value,
    });
  };

  /*********************************
   * @DESC SORT FILTER ACTION
   *********************************/
  const userFilter = [
    { title: `Date & Time 🠑`, disabled: false },
    { title: "Date & Time 🠓", disabled: false },
  ];

  const handleClick = (event) => {
    setState({
      ...state,
      displaySearch: false,
      displayFilter: false,
    });
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
    setState({
      ...state,
      displaySearch: false,
      displayFilter: false,
    });
  };
  const onClickSetUserSort = (title) => {
    setUserSort(title);
    setAnchorEl(null);
  };

  const [userRequestRegistration, setUserRequestRegistration] = useState([]);

  useEffect(() => {
    setUserRequestRegistration(props.userRegistrations);
  }, [props.userRegistrations]);

  let filteredData = userRequestRegistration && userRequestRegistration;

  if (userSort === "Date & Time 🠑") {
    filteredData = filteredData.sort(
      (a, b) => new Date(a?.updatedAt) - new Date(b?.updatedAt)
    );
  } else if (userSort === "Date & Time 🠓") {
    filteredData = filteredData.sort(
      (a, b) => new Date(b?.updatedAt) - new Date(a?.updatedAt)
    );
  }

  if (!isEmpty(state.search)) {
    filteredData = filteredData.filter((item) => {
      return item?.mobile_number
        .toLowerCase()
        .includes(state.search.toLowerCase());
    });
  }

  if (!isEmpty(state.filterNumber)) {
    filteredData = filteredData.filter((item) => {
      return parseInt(item?.mobile_number) === parseInt(state.filterNumber);
    });
  }

  //   useEffect(() => {
  //     const token = props.auth.user.accessToken;
  //     props.userRegistrations_Amealio_get(token,dateQuery);
  //   }, []);

  /***********************************
   * @DESC FILTER BUTTON ACTION
   ***********************************/
  const onClickShowFilter = (e) => {
    e.preventDefault();
    setState({
      ...state,
      displayFilter: !state.displayFilter,
      displaySearch: false,
      filterNumber: "",
    });
    formik.resetForm();
  };

  const formik = useFormik({
    initialValues: {
      mobileNumber: "",
    },
    validationSchema: yup.object({
      mobileNumber: yup.number().required("Contact number is required"),
    }),
    onSubmit: (values) => {
      onSuccessFilterData(values.mobileNumber);
    },
  });

  const onSuccessFilterData = (data) => {
    setState({
      ...state,
      displayFilter: false,
      filterApply: true,
      filterNumber: data,
    });
  };

  const onClickResetFilter = () => {
    formik.resetForm();
    onSuccessResetFilter();
  };

  const onSuccessResetFilter = () => {
    setState({
      ...state,
      filterApply: false,
      displayFilter: false,
      filterNumber: "",
    });
  };

  const [count, setCount] = useState(1);
  const onClickSave = (e) => {
    e.preventDefault();
    setCount(count + 1);
    formik.handleSubmit();
  };

  useEffect(() => {
    if (formik.errors && formik.errors.mobileNumber) {
      let mobileNumberElement = document.getElementById("mobileNumber");
      mobileNumberElement.focus();
    }
  }, [count]);

  /******************************
   * Download Reports
   *****************************/
  const downloadData = {
    headers: [
      { label: "S.No.", key: "serialNo" },
      { label: "User Contact No.", key: "contactNo" },
      { label: "Created Date", key: "createDate" },
      { label: "How Old Is User Request", key: "updateDate" },
    ],
    data: filteredData
      ? filteredData &&
      filteredData?.map((ele, index) => {
        return {
          serialNo: `${index + 1 || ""}`,
          contactNo: `${ele?.mobile_number || " "}`,
          createDate: `${moment(ele?.createdAt).format(
            "Do MMM YYYY hh:mm A"
          )}`,
          updateDate: `${moment(new Date()).diff(
            ele?.createdAt,
            "days"
          )} Days`,
        };
      })
      : [],
  };

  // const countRegistrations = () => {
  //   let activeCount = 0;
  //   for (let i = 0; i < data && data.length; i++) {
  //     if (data[i]) {
  //       activeCount += 1;
  //     }
  //   }
  //   return activeCount;
  // };

  const maxLengthCheck = (object) => {
    if (object.target.value.length > object.target.maxLength) {
      object.target.value = object.target.value.slice(
        0,
        object.target.maxLength
      );
    }
  };

  return (
    <React.Fragment>
      <div className="container-fluid">
        <div className="row">
          <div className="left-side-panel">
            <LeftSideNavigation displayLink={1} />
          </div>
          <div className="super-admin-right-side-panel">
            <HomeReusableTopBarNavigation displayText="Reports" />
            <div className="super-admin-inside-right-side-panel">
              <div className="d-flex justify-content-between align-items-center pt-4 pb-3">
                <div className="f24_700_HelveticaNeue">
                  User Registration Report Amealio Website
                  <br />
                </div>
                <div>
                  <div
                    align="right"
                    style={{ color: "#9E9E9E" }}
                    className="f10-400 my-2"
                  >
                    Report Run Date: {moment().format("Do MMM, YYYY")}
                  </div>
                  <span
                    className="f12-400 text-grey"
                    style={{ color: "#9E9E9E" }}
                  >
                    Report Range Date:
                  </span>
                  <span className="f12-500">
                    {" "}
                    {moment(dateQuery?.startDate).format("Do MMM, YYYY")} {"-"}{" "}
                    {moment(dateQuery?.endDate).format("Do MMM, YYYY")}
                  </span>
                </div>
              </div>
              <div className="row">
                <div className="col-4 d-flex">
                  <Image
                    //   onClick={() =>
                    //     setState({
                    //       ...state,
                    //       showSearch: !state.showSearch,
                    //     })
                    //   }
                    alt="filter"
                    title="filter"
                    width="80px"
                    className="cursor"
                    src={require("../../../../assets/images/iconButton/newsearchicon.svg")}
                  />
                  {/*<div
                    className="f10-400 cursor"
                    align="center"
                    onClick={(e) => onClickShowFilter(e)}
                  >
                    <img
                      src={require("../../../../assets/images/iconButton/filterbtn.svg")}
                      width="80px"
                    />
                  </div>*/}
                  <div
                    className="f10-400 cursor"
                    align="center"
                    aria-controls="simple-menu"
                    aria-haspopup="true"
                    onClick={(event) => handleClick(event)}
                  >
                    <img
                      src={require("../../../../assets/images/iconButton/sortbtn.svg")}
                      width="80px"
                    />
                  </div>
                  <div className="f10-400" align="center">
                    <CSVDownloader
                      filename={"User_Registraion"}
                      headers={downloadData?.headers}
                      data={downloadData?.data}
                    />
                    <br />
                  </div>
                </div>
                <div className="col-3"></div>
                <div className="col-5 d-flex justify-content-end">
                  <div className="mr-3">
                    <SelectFilter onDateChange={onDateChangeHandler()} />
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-9">
                  <Menu
                    id="simple-menu"
                    anchorEl={anchorEl}
                    keepMounted
                    open={Boolean(anchorEl)}
                    onClose={() => handleClose}
                  >
                    {userFilter.map((ele, index) => {
                      return (
                        <MenuItem
                          value={ele?.title}
                          key={index}
                          onClick={() => onClickSetUserSort(ele?.title)}
                          disabled={ele?.disabled}
                        >
                          {ele?.title}
                        </MenuItem>
                      );
                    })}
                  </Menu>
                  {state.displaySearch && (
                    <div className="mb-3 w-50">
                      <ZoomDiv>
                        <>
                          <Form.Control
                            type="number"
                            placeholder="Search by Contact Number"
                            name="search"
                            onChange={(e) => onChangeSearch(e)}
                            value={state.search}
                            className="amSearch"
                          />
                        </>
                      </ZoomDiv>
                    </div>
                  )}
                  <div className="container-fluid">
                    <div className="row">
                      {state.displayFilter ? (
                        <Col sm={12} md={12} lg={12} xl={12}>
                          <Form noValidate onSubmit={(e) => onClickSave(e)}>
                            <Col sm={12} md={12}>
                              <Row
                                className="py-3 bg-white d-flex align-items-center"
                                style={{
                                  height: "22vh",
                                  boxShadow: "0px 3px 6px #6E6E6E21",
                                  borderRadius: 5,
                                }}
                              >
                                <Col sm={4}>
                                  <NewInputText
                                    extraClass="mb-1"
                                    name="mobileNumber"
                                    maxLength={10}
                                    onInput={maxLengthCheck}
                                    inputType="number"
                                    onFocusOut={formik.handleBlur}
                                    onChange={formik.handleChange}
                                    value={formik.values.mobileNumber}
                                    labelText="User Contact Number"
                                    controlClass="mobileNumber"
                                  />
                                  {formik.errors.mobileNumber &&
                                    formik.touched.mobileNumber ? (
                                    <div className="f10-500 text-danger mt-1">
                                      {formik.errors.mobileNumber}
                                    </div>
                                  ) : null}
                                </Col>
                                <Col
                                  sm={12}
                                  className={
                                    "d-flex align-items-center justify-content-end"
                                  }
                                >
                                  <Button
                                    variant="outline-secondary"
                                    className="px-4 py-2 f14-400"
                                    style={{
                                      borderRadius: 5,
                                    }}
                                    title="Cancel"
                                    onClick={(e) => onClickShowFilter(e)}
                                  >
                                    Cancel
                                  </Button>
                                  <Button
                                    variant="danger"
                                    className="px-4 py-2 text-white f14-400 ml-3"
                                    style={{
                                      borderRadius: 5,
                                      backgroundColor: "#EE3A23",
                                    }}
                                    type="Submit"
                                    title="Filter Submit"
                                  >
                                    Submit
                                  </Button>
                                </Col>
                              </Row>
                            </Col>
                          </Form>
                        </Col>
                      ) : null}
                      {state.filterApply ? (
                        <Col
                          sm={12}
                          md={12}
                          lg={12}
                          xl={12}
                          className={`${state.displayFilter ? "mt-3" : ""}`}
                        >
                          <Button
                            variant="danger"
                            className="px-4 py-2 text-white"
                            style={{
                              borderRadius: 5,
                              fontSize: 12,
                              backgroundColor: "#EE3A23",
                            }}
                            type="button"
                            title="Reset Filter"
                            onClick={(e) => onClickResetFilter(e)}
                          >
                            Reset Filter
                          </Button>
                        </Col>
                      ) : null}
                    </div>
                  </div>
                </div>
                <div className="col-3">
                  <div
                    className="d-flex  mt-3 mb-3"
                    style={{ justifyContent: "space-between" }}
                  >
                    <div className="mr-3 d-flex">
                      {/* <SelectFilter onDateChange={onDateChangeHandler()} /> */}
                    </div>
                    <RightSideCountTop
                      content={[
                        {
                          name: "Total No. of Registered users",
                          //  loader: props.auth.secondary_loader,
                          value: props?.userRegistrations?.length,
                          backgroundColor: "#D8F3F4",
                          color: "#138B90",
                        },
                      ]}
                    />
                  </div>
                </div>
              </div>
              <div className="col-12 p-0 user-table-reusable-superadmin super-admin-all-vendor-main">
                {/* <div className="col-12 p-0 user-table-reusable-superadmin table-responsive"> */}
                <Table className="">
                  <thead>
                    <tr className="super_admin_all_users_table_head">
                      <td style={{ width: "15%" }} className="f12-400">
                        contact <br /> Number
                      </td>
                      <td style={{ width: "15%" }} className="f12-400">
                        Regisration <br />
                        Date & Time
                      </td>
                    </tr>
                  </thead>
                  {props?.auth?.loader ? (
                    <div className="text-center">
                      <Loader
                        type="Bars"
                        color="#00BFFF"
                        height={100}
                        width={100}
                      />
                    </div>
                  ) : filteredData && filteredData.length <= 0 ? (
                    <NoContent />
                  ) : (
                    !isEmpty(filteredData) ?
                      filteredData.slice(start, end).map((ele, index) => (
                        <React.Fragment key={index}>
                          <TableBody data={ele} key={index} />
                        </React.Fragment>
                      ))
                      : <NoContent />
                  )}
                  {/* {filteredData &&
                    filteredData.map((ele, index) => (
                      <TableBody data={ele} key={index} />
                    ))} */}
                </Table>
              </div>
              {state.search !== "" ? (
                ""
              ) : (
                <div className="row w-100">
                  <div className="col-12">
                    {!isEmpty(filteredData) && filteredData.length !== 0 ? (
                      <BasicPagination
                        totalRecords={props?.userRegistrations?.length}
                        limit={10}
                        batch={page}
                        onBatchChange={(e) => handleBatchChange(e)}
                      />
                    ) : (
                      <></>
                    )}
                  </div>
                </div>
              )}
              {/* <div className="p4v2-menu-pagination">
                <BasicPagination
                  totalRecords={props?.userRegistrations?.length}
                  limit={10}
                  batch={page}
                  onBatchChange={(e) => handleBatchChange(e)}
                />
              </div> */}
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}

const TableBody = (props) => {
  let ele = props.data;
  return (
    <tbody className="w-100 super-admin-all-vendor-main-table-body">
      <tr className="w-100 p-0">
        <td className="p-0 w-100">
          <table className="w-100">
            <tbody className="sd_body_css">
              <tr className="sd_body_table-row pl-1">
                <td style={{ width: "15%" }}>
                  <div>
                    <h5 className="font_16_m mt-3">
                      {ele?.mobile_number.replace(/\d(?=\d{3})/g, "*")}
                    </h5>
                  </div>
                </td>
                <td style={{ width: "15%" }}>
                  <div className="f14-400">
                    {" "}
                    {moment(ele && ele.createdAt).format("Do MMM, YY")} <br />
                    {moment(ele && ele.createdAt).format("h:mm: a")} <br />
                    {/* {moment(ele && ele.createdAt)
                      .format("Do MMM, YY")
                      .fromNow(true)} */}
                    {moment(new Date()).diff(ele?.createdAt, "days")} days
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </td>
      </tr>
    </tbody>
  );
};

// export default UserRegistrationAmealio;

UserRegistrationAmealio.propTypes = {
  auth: PropTypes.object.isRequired,
  userRegistrations: PropTypes.array.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  userRegistrations: state.reports.user_registrations_amealio,
});

export default connect(mapStateToProps, {
  userRegistrations_Amealio_get,
})(UserRegistrationAmealio);
